import { useMemo } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import useAuth from "../../shared/hooks/useAuth";
import CustomSpinner from "../../shared/components/customSpinner/customSpinner";
import { Box } from "@mui/material";
import { POST_LOGIN_REDIRECT_KEY } from "../../shared/constants/constants";
import MiniDrawer from "../drawer/drawer";

const PrivateRoutes = () => {
  const loggedIn = useAuth(true); // Use stable value instead of Math.random()
  const location = useLocation();

  if (loggedIn === undefined) {
    return <CustomSpinner />;
  }

  if (loggedIn === false) {
    // Remember the originally requested URL so we can return here after
    // login (e.g. a deep link from a WhatsApp notification). Router state
    // doesn't survive the multi-step OTP flow (sendOtp/verifyOtp each set
    // their own navigation state), so sessionStorage is used instead.
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, `${location.pathname}${location.search}`);
    return <Navigate to="/signin" />;
  }

  if (location.pathname === "/") {
    // If the current location is '/', redirect to the dashboard
    return <Navigate to="/dashboard" />;
  }

  // Otherwise, render the child routes
  return <Box sx={{ display: "flex", justifyContent: "center", flexGrow: 1, width: "100%" }}>
      <MiniDrawer>
        <Outlet/>
      </MiniDrawer>
    </Box>;
};

export default PrivateRoutes;
